<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="!page.isNew" id="btnConfigureControlID" type="button" elevation="0"
                            color="secondary" outlined :loading="dataset.configuring"
                            @click="configureControlID">Configurar ControlID</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark
                            @click="page.isNew ? add() : update()" :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/equipamentos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense :items="dataset.equipmentTypes" label="Tipo de Equipamento"
                                                v-model="dataset.data.type" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense :items="dataset.actionTypes" label="Ação"
                                                v-model="dataset.data.action_type" item-value="id" item-text="name"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Endereço IP" v-model="dataset.data.ip" required
                                                outlined hide-details="auto" :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Identificador" v-model="dataset.data.uuid"
                                                required outlined hide-details="auto" :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense :items="dataset.equipmentStatus" label="Status"
                                                v-model="dataset.data.is_active" item-value="value" item-text="name"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense type="number" label="Limite de faces"
                                                v-model.number="dataset.data.face_capacity_limit" outlined
                                                hide-details="auto" hint="iDFace Lite: 3000 faces">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="!page.isNew">
                                            <v-text-field dense label="Faces sincronizadas"
                                                :value="`${dataset.data.face_count || 0} / ${dataset.data.face_capacity_limit || 3000}`"
                                                outlined readonly hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" v-if="!page.isNew">
                                            <v-chip class="mt-1" :color="faceCapacityColor(dataset.data.face_capacity_status)" label outlined>
                                                {{ faceCapacityLabel(dataset.data.face_capacity_status) }}
                                                <span v-if="dataset.data.face_capacity_percent !== undefined">
                                                    &nbsp;· {{ Number(dataset.data.face_capacity_percent || 0).toFixed(2) }}%
                                                </span>
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select multiple dense :items="dataset.equipments" label="Equipamentos"
                                                v-model="dataset.data.associations" item-value="id" item-text="name"
                                                outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import actionTypes from "@/common/data/action-types.data"

import equipmentTypes from "@/common/data/equipment-types.data"
import equipmentStatus from "@/common/data/equipment-status.data"

import axios from "axios"

export default {
    name: "EquipmentDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            equipmentTypes: equipmentTypes,
            actionTypes: actionTypes,
            equipmentStatus: equipmentStatus,
            data: {},
            loading: false,
            configuring: false,
        },
        dataForm: {
            validForm: true,
            updateLoading: false,
            removeLoading: false,
        },
    }),

    created() {
        this.page.isNew = this.$route.params.id == "novo"

        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/equipamentos");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
            await this.loadEquipments();
        },

        setPage() {
            this.page.title = `Detalhes do Equipamento`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de equipamentos",
                disabled: false,
                to: "/equipamentos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes do equipamento`,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.$route.params.id == "novo") return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v1/equipments/${this.$route.params.id}`);

                this.dataset.data = result.data.content
                this.dataset.data.associations = this.dataset.data.associations.map((x) => x.id)

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao buscar o equipamento, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadEquipments() {
            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v1/equipments`, { params: { limit: 10000 } });

                this.dataset.equipments = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao buscar os equipamentos, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o equipamento?',
                title: 'Incluir equipamento',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/equipments', payload);

                this.$dialog.notify.info("Equipamento salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o equipamento?',
                title: 'Atualizar equipamento',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/equipments/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Equipamento salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                type: this.dataset.data.type,
                action_type: this.dataset.data.action_type,
                ip: this.dataset.data.ip,
                uuid: this.dataset.data.uuid,
                is_active: this.dataset.data.is_active,
                face_capacity_limit: this.dataset.data.face_capacity_limit || 3000,
                associations: this.dataset.data.associations
            }

            return data;
        },

        edgeApiBaseUrl() {
            return process.env.VUE_APP_EDGE_API_URL
                || localStorage.getItem("edge_api_url")
                || "http://localhost:3001";
        },

        edgePublicUrl() {
            return process.env.VUE_APP_EDGE_PUBLIC_URL
                || localStorage.getItem("edge_public_url")
                || null;
        },

        edgeAdminToken() {
            return process.env.VUE_APP_EDGE_ADMIN_TOKEN
                || localStorage.getItem("edge_admin_token")
                || null;
        },

        async configureControlID() {
            if (!this.dataset.data.ip) {
                this.$dialog.notify.error("Informe o IP do equipamento antes de configurar.", {
                    position: "top-right",
                    timeout: 2500
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: "Deseja enviar a configuração para este equipamento ControlID?",
                title: "Configurar equipamento",
                actions: {
                    false: "Cancelar",
                    true: "Configurar"
                }
            });

            if (!proceedAction) return;

            this.dataset.configuring = true;

            const edgeClient = axios.create({
                baseURL: this.edgeApiBaseUrl(),
                timeout: 30000,
            });

            const headers = {};
            const token = this.edgeAdminToken();
            if (token) headers["x-edge-token"] = token;

            try {
                await edgeClient.post("/api/equipment-config/registered", {
                    equipment: this.buildPayload(),
                    serverUrl: this.edgePublicUrl(),
                }, { headers });

                this.$dialog.notify.info("Configuração enviada ao equipamento com sucesso.", {
                    position: "top-right",
                    timeout: 2500
                });
            } catch (error) {
                const message = error.response && error.response.data && error.response.data.content
                    ? error.response.data.content.message || JSON.stringify(error.response.data.content)
                    : "Não foi possível configurar o equipamento. Verifique se o Edge local está online e se o IP está acessível.";

                this.$dialog.notify.error(message, {
                    position: "top-right",
                    timeout: 4000
                });
            } finally {
                this.dataset.configuring = false;
            }
        },

        faceCapacityColor(status) {
            switch (status) {
                case 'full':
                    return 'error'
                case 'critical':
                    return 'error'
                case 'attention':
                    return 'warning'
                default:
                    return 'success'
            }
        },

        faceCapacityLabel(status) {
            switch (status) {
                case 'full':
                    return 'Limite atingido'
                case 'critical':
                    return 'Capacidade crítica'
                case 'attention':
                    return 'Atenção'
                default:
                    return 'Capacidade normal'
            }
        },




    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
